import React, { memo } from 'react'
import { NavLink } from "react-router-dom"
const Tjsj = memo(() => {
  return (
    <div className='contentwarp'>
      <div className="banner">
      <img src={ window.bannerImg?window.bannerImg:'./img/homebanner.png'} alt="" />
        <NavLink className="gohome" to='/'>
          <svg t="1621560571353" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2402" width="64" height="64"><path d="M562.9 80.9C535.4 56 493.5 56 466 80.9L74 453.1c-14.7 13.5-15.7 36.4-2.2 51.1 13.3 14.5 35.8 15.7 50.6 2.6l6.2-5.9v388.4c0 39.9 32.3 72.4 72.2 72.4h210.5V744c0-28.1 22.7-50.9 50.8-51h99.1c28.1 0 50.9 22.8 50.9 50.9V961.7h215.4c39.9 0 72.3-32.4 72.3-72.3V505.7c16.1 14.5 38.9 13.4 52.2-1.5 13.4-14.8 12.2-37.7-2.6-51.1L562.9 80.9z" p-id="2403" fill="#ffffff"></path></svg>
        </NavLink>
      </div>
      <div className='contentTop'>

        <div className="content">
          <div className='ctitile'>组织单位</div>
          <p className='desc' style={{ 'textIndent': '0' }}>
            <span><strong>主办单位：</strong>北京市生态环境局、中共北京市委宣传部、中共北京市委网络安全和信息化委员会办公室、北京市发展和改革委员会、北京市教育委员会、北京市科学技术委员会（中关村科技园区管理委员会）、北京市城市管理委员会、北京市农业农村局、北京市文化和旅游局、共青团北京市委员会、北京市妇女联合会、北京冬奥组委总体策划部</span><br />
            <span><strong>承办单位：</strong>北京市环境保护宣传中心</span><br />
          </p>
        </div>
      </div>
    </div>
  )
})
export default Tjsj